interface Props {
  tableNo: string;
  variant?: "order" | "payment";
  label?: string;
  onClick?: () => void;
}

const variantStyle = {
  order: { bg: "#12B981", subColor: "#FFFFFF", defaultLabel: "Order Details" },
  payment: { bg: "#F15A29", subColor: "#FFFFFF", defaultLabel: "Pay" },
} as const;

const OrderCard = ({ tableNo, variant = "order", label, onClick }: Props) => {
  const v = variantStyle[variant];
  return (
    <button type="button" onClick={onClick} className="w-full bg-white rounded-[6px] border border-[#E6EEFF] flex flex-col items-center gap-2 py-2 px-2 border-0">
      <span className="font-sansation font-bold text-[24px] leading-none" style={{ color: v.bg }}>
        {tableNo}
      </span>
      <span className="w-full text-center font-sansation font-bold text-[10px] text-white px-2 py-1 rounded-[6px]" style={{ backgroundColor: v.bg }}>
        {label ?? v.defaultLabel}
      </span>
    </button>
  );
};

export default OrderCard;
